"use client";

import { useEffect, useMemo, useRef } from 'react';
import styles from './_hcp-long-button.module.scss';
import Button from "@/components/button";
import { renderToString } from 'react-dom/server';

export default function HcpLongButton({
  label = null,
  description = null,
  iconType = undefined,
  hideDropShadow = false,
  customClass = '',
  ...rest
}) {
  const containerRef = useRef(null);

  useEffect(() => {
    if (iconType) {
      //const src = `/images/icons/icon-long-button-${iconType}.svg`; //below is the new naming convention from hcp seo doc
      const src = `/images/icons/${iconType}-Icon.svg`;
      containerRef.current?.style.setProperty('--icon-src', `url(${src})`);
    }
  }, [iconType]);

  const containerClass = useMemo(() => {
    let className = `${styles.container} ${customClass}`;

    if (hideDropShadow) {
      className = `${className} ${styles.hide_drop_shadow}`
    }

    return className;
  }, [hideDropShadow, customClass]);

  return (
    <div className={`${containerClass} ${iconType === "PeerConnect" ? styles.peerconnect : ""}`} ref={containerRef}>
      <div className={styles.background} />
      <div className="container">
        <Button
          data-gtm-event-category="Internal Link"
          data-gtm-event-action="Click"
          data-gtm-event-label={renderToString(label)}
          {...rest}
        >
          <div className={styles.content}>
            <p className={styles.label}>
              {label}
            </p>
            <p className={styles.description}>
              {description}
            </p>
          </div>
        </Button>
      </div>
    </div>
  );
}